<template>
  <div class="offline-quality-control">
    <!-- 面访审核 -->
    <ItemContainer :title="`${reviewTitle ? reviewTitle : '面访审核'}`">
      <div>
        <span class="text-medium font-normal leading-22 text-theme-black-650" v-if="reviewContent">
          {{ reviewContent }}
        </span>
        <span class="text-medium font-normal leading-22 text-theme-black-650" v-else> 对面访回收的答卷进行人工审核 </span>
        <span class="text-small text-theme-black-450 mr-6"> （可设置多人、多级人工审核） </span>
        <el-switch v-model="trueSwitch" disabled></el-switch>
      </div>
      <div class="mt-3">
        <el-button size="small" type="primary" @click="advancedSettings">审核设置</el-button>
        <span class="pl-3">
          <el-button size="small" @click="toAuditData">前往审核</el-button>
        </span>
      </div>
    </ItemContainer>

    <!-- 人工审核设置 -->
    <ManualReview
      v-if="ManualReviewFlag"
      :visible="true"
      :auditRa="auditRadio"
      :deadlineR="deadlineRed"
      :deadlineA="deadlineAll"
      @close="ManualReviewFlag = false"
      @manual-review="peopleExamineHandler"
    />

    <!-- 答题过程质控 -->
    <ItemContainer>
      <!-- 标题 -->
      <template slot="title">
        <p class="ml-5 font-semibold text-medium-x leading-22 text-theme-black-850">
          答题过程质控
          <span class="text-small text-theme-black-450 font-normal"> （开启答题过程质控后，可在答卷详情中查看质控证据） </span>
        </p>
      </template>

      <!-- 内容 -->
      <div class="text-medium font-normal leading-22 text-theme-black-650 mb-2">
        <span>对答题全程进行录音或录像，作为质控证据</span>
        <el-switch v-model="videoFlag" class="ml-6 -mt-px" @change="onChangeInterView"></el-switch>
      </div>
      <div class="card bg-card-bg-gray py-3 pl-4 mb-6" v-if="videoFlag">
        <el-radio-group v-model="radio" @change="onChangeInterView">
          <el-radio :label="2" :disabled="disabled" class="mr-10 text-theme-black-650">全程录音</el-radio>
          <el-radio :label="3" :disabled="disabled" class="mr-10 text-theme-black-650">全程前摄像头录像</el-radio>
          <el-radio :label="4" :disabled="disabled" class="text-theme-black-650">全程后摄像头录像</el-radio>
        </el-radio-group>
      </div>

      <!-- todo 专门题目的质控 -->
      <div class="mt-3 mb-2 text-medium font-normal leading-22 text-theme-black-650">
        作答指定题目时，手机摄像头静默拍照，作为质控证据
        <template>
          <el-tooltip
            class="item"
            effect="light"
            content="静默拍照会中断答题全程录音录像，全程记录可能被分为多段"
            placement="top"
          >
            <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-1 mr-6 text-medium"></i>
          </el-tooltip>
        </template>
        <el-switch v-model="photoFlag" disabled class="-mt-px"></el-switch>
      </div>
      <div class="card bg-card-bg-gray py-3 pl-4" v-if="photoFlag">
        <el-select v-model="questionValue" placeholder="请选择题目" style="width: 312px" class="bg-white-input mr-3" multiple>
          <el-option v-for="item in questionOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>

        <el-select v-model="photoValue" placeholder="拍照方式" class="bg-white-input" style="width: 168px">
          <el-option v-for="item in photoOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </div>
    </ItemContainer>

    <!-- 调查员权限 -->
    <ItemContainer :title="'调查员权限'">
      <!-- 标题 -->
      <template slot="title">
        <p class="ml-5 font-semibold text-medium-x leading-22 text-theme-black-850">
          <span>调查员权限</span>
          <span class="text-small text-theme-black-450 font-normal" v-if="powerSubTitle">
            {{ powerSubTitle }}
          </span>
        </p>
      </template>

      <!-- 内容 -->
      <div class="text-medium font-normal leading-22 text-theme-black-650 mb-3">
        <span v-if="powerContent">{{ powerContent }}</span>
        <span v-else>调查员可见面访答题时记录的多媒体素材</span>
        <span class="text-small text-theme-black-450">（照片、录音、录像）</span>
        <el-switch v-model="mediaFlag" class="ml-6" @change="showMediaChange($event, 'enableShowMultimedia')"></el-switch>
      </div>
      <div class="text-medium font-normal text-theme-black-650 leading-22">
        <span>调查员可以修改已完成未上报的答卷</span>
        <el-switch
          v-model="changeFlag"
          class="ml-6 leading-22 -mt-px"
          @change="modifyWJChange($event, 'canEditSubmittedAppAnswer')"
        ></el-switch>
      </div>
    </ItemContainer>

<!--    <ItemContainer title="横屏拍照">-->
<!--      <landscape/>-->
<!--    </ItemContainer>-->
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import { saveSurveySetting } from '@/api/wenjuan/publish'
import ItemContainer from '@/components/base/ItemContainer'
import ManualReview from '@/components/manual-review/ManualReview'
import { preWj, setSaveInterviewRequirements } from '@/api/wenjuan/wjquestion'
import Landscape from '@/views/survey/offline/components/Landscape.vue'

export default {
  name: 'OfflineQualityControl',
  components: { Landscape, ItemContainer, ManualReview },
  props: {
    reviewTitle: String,
    reviewContent: String,
    powerSubTitle: String,
    powerContent: String
  },
  data() {
    return {
      survey: {
        id: '',
        otherSetting: {}
      },
      trueSwitch: true,
      ManualReviewFlag: false, // 人工审核开关
      peopleExamine: false, // 答卷审核部分 - 人工审核开关
      // 答题过程质控部分
      videoFlag: false,
      photoFlag: false,
      disabled: false,
      radio: null,
      questionValue: '',
      questionOptions: [
        {
          value: '选项1',
          label: 'Q1. AAAAAAA'
        },
        {
          value: '选项2',
          label: 'Q2. BBBBBBB'
        }
      ],
      photoValue: '',
      photoOptions: [
        {
          value: '选项1',
          label: '前置摄像头拍照'
        },
        {
          value: '选项2',
          label: '后置摄像头拍照'
        }
      ],
      // 调查员权限部分
      mediaFlag: false,
      changeFlag: false,
      auditRadio: '',
      deadlineRed: 2,
      deadlineAll: 2
    }
  },
  methods: {
    getParams(v, n) {
      let params = {
        id: this.survey.id,
        otherSetting: {}
      }
      params.otherSetting[n] = v
      return params
    },
    getParamsManRev(value) {
      let { enableNetManualAudit = value.val, auditRadio, deadlineRed, deadlineAll } = value.auditRadioP
      let params = { id: this.survey.id }
      if (enableNetManualAudit) {
        if (auditRadio == 'enableAuditForRedEnvelopes') {
          params.otherSetting = {
            enableNetManualAudit: true,
            enableAuditForRedEnvelopes: true,
            auditForRedEnvelopesAutoPassTime: deadlineRed
          }
        } else {
          params.otherSetting = {
            enableNetManualAudit: true,
            enableAuditForRedEnvelopes: false,
            auditForRedEnvelopesAutoPassTime: deadlineAll
          }
        }
      } else {
        params.otherSetting = { enableNetManualAudit: false }
      }
      return params
    },
    // 答卷审核-第一部分
    peopleExamineHandler(value, string) {
      // 判断是否由子组件调用
      let val, str, flag, obj
      if (typeof value === 'object') {
        flag = value.val
        obj = this.getParamsManRev(value)
      } else {
        val = value
        str = string
        obj = this.getParams(val, str)
      }
      saveSurveySetting(obj)
        .then(res => {
          this.$message.success('答卷回收渠道保存成功!')
          if (typeof value === 'object') this.peopleExamine = flag
        })
        .catch(e => {
          this.$message.error(e.message)
        })
    },
    advancedSettings() {
      this.ManualReviewFlag = true
      this.preWj()
    },
    // 录音录像-第二部分
    onChangeInterView(value) {
      if (!value) {
        value = 1
      } else if (typeof value === 'boolean' && value) {
        return
      }
      this.disabled = true
      setSaveInterviewRequirements({ id: this.survey.id, interviewRequirements: value })
        .then(res => {
          this.$message.success('设置成功！')
          this.disabled = false
        })
        .catch(e => {
          this.$message.error(`设置失败 ${e.message}`)
        })
    },
    // 可以查看多媒体素材-第三部分
    showMediaChange(value, string) {
      let params = this.getParams(value, string)
      saveSurveySetting(params)
        .then(res => {
          this.$message.success('设置成功！')
        })
        .catch(e => {
          this.$message.error(`设置失败 ${e.message}`)
        })
    },
    // 修改已提交答卷
    modifyWJChange(value, string) {
      let params = this.getParams(value, string)
      saveSurveySetting(params)
        .then(res => {
          this.$message.success('设置成功！')
        })
        .catch(e => {
          this.$message.error(`设置失败 ${e.message}`)
        })
    },
    toAuditData() {
      this.$router.push(`/survey/${GlobalConfig.getSurveyId()}/data/data-examine/pending-review`)
    },
    preWj() {
      const setComponentParams = params => {
        const { auditRadio = 'enableNetManualAudit', deadlineRed = 2, deadlineAll = 2, peopleExamine } = params
        ;[this.auditRadio, this.deadlineRed, this.deadlineAll, this.peopleExamine] = [
          auditRadio,
          deadlineRed,
          deadlineAll,
          peopleExamine
        ]
      }
      preWj(this.survey.id).then(res => {
        // 获取问卷数据
        this.survey = res.data.data

        // 处理开关状态及抽屉组件传参
        const otherSetting = res.data.data.otherSetting
        if (otherSetting) {
          // 可见多媒体素材
          otherSetting.hasOwnProperty('enableShowMultimedia')
            ? (this.mediaFlag = otherSetting.enableShowMultimedia)
            : (this.mediaFlag = true)
          // 面访审核
          otherSetting.hasOwnProperty('enableNetManualAudit') && (this.peopleExamine = otherSetting.enableNetManualAudit)
          // 可修改问卷
          otherSetting.hasOwnProperty('canEditSubmittedAppAnswer') && (this.changeFlag = otherSetting.canEditSubmittedAppAnswer)
        }
        this.radio = res.data.data && res.data.data.interviewRequirements
        this.radio === 1 ? (this.videoFlag = false) : (this.videoFlag = true)
        if (otherSetting.enableAuditForRedEnvelopes && otherSetting.enableNetManualAudit) {
          setComponentParams({
            auditRadio: 'enableAuditForRedEnvelopes',
            deadlineRed: otherSetting.auditForRedEnvelopesAutoPassTime,
            peopleExamine: true
          })
        } else if (otherSetting.enableNetManualAudit && !otherSetting.enableAuditForRedEnvelopes) {
          setComponentParams({
            deadlineAll: otherSetting.auditForRedEnvelopesAutoPassTime,
            peopleExamine: true
          })
        } else if (!otherSetting.enableNetManualAudit) {
          setComponentParams({ peopleExamine: false })
        }
      })
    }
  },
  created() {
    this.survey.id = GlobalConfig.getSurveyId()
    this.preWj()
  }
}
</script>

<style lang="scss" scoped></style>
